import script from "./PodcastDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastDetails.vue?vue&type=script&setup=true&lang=js"

import "./PodcastDetails.vue?vue&type=style&index=0&id=620ef76b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620ef76b"]])

export default __exports__